import {
  resolveProactiveGreetingPageTitle,
  toProactiveGreetingPageType,
  toProactiveGreetingProduct,
  truncateProactiveGreetingDescription,
  type ProactiveGreetingPage,
} from '@teo/widget-shared';
import { collectPageContextAsync } from './parse-page-context.js';

export type BuildWidgetPageOptions = {
  url?: string;
  /** When false, only URL/pathname/title heuristics (no full parser). Default true. */
  pageContextEnabled?: boolean;
};

/** Same `page` shape as `POST /greeting` — used for greeting and send. */
export async function buildWidgetPage(
  options: BuildWidgetPageOptions = {},
): Promise<ProactiveGreetingPage> {
  const pageUrl =
    options.url ??
    (typeof window !== 'undefined' ? window.location.href : 'https://localhost/');
  const context = await collectPageContextAsync({
    url: pageUrl,
    fullContext: options.pageContextEnabled !== false,
  });
  const pageTitle = resolveProactiveGreetingPageTitle(context);
  const description = truncateProactiveGreetingDescription(context.description);
  const product = toProactiveGreetingProduct(context.product);

  return {
    type: toProactiveGreetingPageType(context.pageType),
    title: pageTitle,
    url: context.url || pageUrl,
    pathname: context.pathname,
    ...(description ? { description } : {}),
    ...(product ? { product } : {}),
  };
}
